import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';
import { AdminRoute } from '@/components/guards/AdminRoute';

export const Route = createFileRoute('/diagnostics/gap-analysis')({
  component: () => (
    <AdminRoute>
      <PageStub title="Gap Analysis" description="Identify improvement areas" />
    </AdminRoute>
  ),
});
